import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Button from '../../../Form/Button/Button';
import ErrorAlert from '../../../Form/ErrorAlert/ErrorAlert';
import TextInput from '../../../Form/TextInput/TextInput';
import { formContent } from './cardContent';
import './PayMoney.css'

const PayMoney = ({isCard, isPayId, paymentDetails}) => {
    const [errorMessage, setErrorMessage] = useState(null);

    const {
        holderName,
        cardNumber,
        expDate,
        cvv,
        payIDnumber,
        paymentButton
    } = formContent

    const formBinding = useForm();

    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));

    const submitForm = async (data) => {

    }

    return(
        <div className="pay-money">
            <ErrorAlert>{errorMessage}</ErrorAlert>
            {isCard && 
            <div className="card-payment">
                <div className="supported-card">
                    <img src="./img/methods.png" alt="card type" />
                </div>
                <div className="payment-details">
                    <div className="price">
                        <h2>${paymentDetails.amount}</h2>
                    </div>
                    <FormProvider {...formBinding}>
                        <form id="payment-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-box">
                                <div className="full-element">
                                    <TextInput {...holderName} />
                                </div>
                                <div className="full-element">
                                    <TextInput {...cardNumber} />
                                </div>
                                <div className="break-element">
                                    <TextInput {...expDate} />
                                    <TextInput {...cvv} />
                                </div>
                                <div className="full-element">
                                    <br />
                                    <Button {...paymentButton} />
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
                
            </div>}
            {isPayId &&
            <div className="pay-id-payment">
                <div className="payment-details">
                    <div className="price">
                        <h2>${paymentDetails.amount}</h2>
                    </div>
                    <FormProvider {...formBinding}>
                        <form id="payment-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-box">
                                <div className="full-element">
                                    <TextInput {...payIDnumber} />
                                </div>
                                
                                <div className="full-element">
                                    <br />
                                    <Button {...paymentButton} />
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>}
        </div>
    )
};

export default PayMoney;
